import React, {useEffect, useState} from "react";
import {
  Box,
  Card,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Button,
  TableContainer,
  TableCell,
  TableRow,
  IconButton,
  Paper, TableBody, TableHead, Table
} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {DeleteSharp, Download} from "@mui/icons-material";
import InputText from "../../../Inputs/InputText/InputText";
import { TableVirtuoso } from "react-virtuoso";
import AddModal from "../AddModal/AddModal";
import EnrollModal from "../EnrollModal/EnrollModal";
import { http } from "../../../../clients/http/http.client";
import { HTTP_ENDPOINTS } from "../../../../clients/clients.constants";
import { setLinked, setSearchEquipment, setUnLinked } from "../../../../store/euqipmentFiltersSlice";
import Tooltip from "@mui/material/Tooltip";
import Loader from "../../../Inputs/Loader/Loader";

const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer  {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table size="small" {...props} style={{ width: '100%', borderCollapse: 'separate', tableLayout: 'fixed' }} />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

  const initialEquipmentData = {
    equipmentType: "",
    // equipmentNumber: "",
    siteId: "",
    tagType: "",
    tagId: ""
  };
  const initialTagData = {
    tagType: "",
    tagId: ""
  };

const EquipmentTableCard = ({
  type = 'equipment',
  textColor = "#000",
  addBtnBackground = '#fff',
  fixedHeaderContent,
  tableBodyRowContent,
  processedEquipment = [],
  equipmentInputs = [],
  handleAddEquipmentSuccess,
  isLoading = false,
  isDebounceRunning = false,
  openTagsExportModal,
  openEquipmentExportModal
}) => {
  const siteIdStore = useSelector((state) => state.siteId);
  const equipmentFilters = useSelector((state) => state.equipmentFilters);
  const [open, setOpen] = useState(false);
  const [targetEntity, setTargetEntity] = useState(type === 'equipment' ? initialEquipmentData : initialTagData);
  const [searchText, setSearchText] = useState(
    type === 'equipment'
      ? equipmentFilters.equipment.search
      : equipmentFilters.tag.search
  );

  useEffect(() => {
    setTargetEntity({...targetEntity, siteId: siteIdStore.siteId})
  }, [open, siteIdStore.siteId])

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setTargetEntity(type === 'equipment' ? initialEquipmentData : initialTagData);
  };

  const handleSubmit = async () => {
    const targetUrl = type === 'equipment' ? HTTP_ENDPOINTS.CREATE_EQUIPMENT : HTTP_ENDPOINTS.CREATE_TAG;
    const data = type === 'equipment' ? targetEntity : { ...targetEntity, siteId: siteIdStore?.siteId || null }

    try {
      const res = await http.client.post(targetUrl, data);
      await handleAddEquipmentSuccess();
    } catch (e) {
      throw e;
    }
  };

  const getCount = () => {
    const counts = processedEquipment.reduce((acc, item) => {
      const itemType = type === 'equipment' ? item.type : item.tagType;
      acc[itemType] = (acc[itemType] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(counts)
      .map(([itemType, count]) => `${count} ${itemType}`)
      .join(', ');
  };

  const dispatch = useDispatch();
  return (
    <Card sx={{ padding: "20px", boxShadow: "0px 4px 40px 0px rgba(226, 236, 249, 0.60)", borderRadius: "12px", marginTop: "15px" }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Tooltip title={getCount()}>
          <Typography sx={{ color: textColor, fontSize: "18px", fontWeight: 600, maxWidth:'260px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{getCount()}</Typography>
        </Tooltip>
        <FormGroup sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
          <FormControlLabel
            control={<Checkbox />}
            onChange={(event) => {dispatch(setLinked({type, value: event.target.checked}))}}
            label={`Enrolled ${type === 'equipment' ? 'Equipment' : 'Tags' }`}
            checked={type === 'equipment' ? equipmentFilters.equipment.linked : equipmentFilters.tag.linked }
            sx={{
              display: 'flex',
              alignItems: 'center',
              ".MuiTypography-root": {
                color: textColor,
                fontSize: "12px"
              },
              ".MuiButtonBase-root": {
                color: textColor,
                padding: "5px",
                "&.Mui-checked": {
                  color: textColor,
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "18px",
                  transform: "translateY(-.5px)"
                }
              }
            }}
          />
          <FormControlLabel
            control={<Checkbox />}
            onChange={(event) => {dispatch(setUnLinked({type, value: event.target.checked}))}}
            label={`Unenrolled ${type === 'equipment' ? 'Equipment' : 'Tags' }`}
            checked={type === 'equipment' ? equipmentFilters.equipment.unlinked : equipmentFilters.tag.unlinked }
            sx={{
              display: 'flex',
              alignItems: 'center',
              ".MuiTypography-root": {
                color: textColor,
                fontSize: "12px"
              },
              ".MuiButtonBase-root": {
                color: textColor,
                padding: "5px",
                "&.Mui-checked": {
                  color: textColor,
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "18px",
                  transform: "translateY(-.5px)"
                }
              }
            }}
          />
          <Button
            variant="contained"
            sx={{
              backgroundColor: addBtnBackground,
              color: textColor,
              fontSize: "14px",
              fontWeight: 600,
              textTransform: 'initial',
              borderRadius: '4px',
              padding: '3px 13px',
              boxShadow: 'none'
            }}
            onClick={() => handleOpen()}
          >
            + Add {type === 'equipment' ? 'equipment' : 'tags' }
          </Button>

          {openEquipmentExportModal && (
              <IconButton
                  color="error"
                  sx={{
                    backgroundColor: addBtnBackground,
                    color: textColor,
                  }}
                  onClick={openEquipmentExportModal}>
                <Download />
              </IconButton>
          )}

          {openTagsExportModal && (
              <IconButton
                  sx={{
                    backgroundColor: addBtnBackground,
                    color: textColor,
                  }}
                  color="primary" onClick={openTagsExportModal}>
                <Download />
              </IconButton>
          )}

          <InputText
            value={searchText}
            onChangeFn={(value) => {dispatch(setSearchEquipment({type, value}))}}
          />
        </FormGroup>
        <AddModal
          open={open}
          handleClose={handleClose}
          type={type}
          inputs={equipmentInputs}
          targetEntity={targetEntity}
          setInputValues={setTargetEntity}
          onSubmit={handleSubmit}
          textColor={textColor}
          backgroundColor={addBtnBackground}
        />
      </Box>
      <Paper style={{ height: 250, width: '100%', marginTop: '10px', boxShadow: 'none' }}>
        {
          isLoading || isDebounceRunning
            ? <Loader sx={{
              height: '260px'
            }} />
            :<TableVirtuoso
              data={processedEquipment}
              components={VirtuosoTableComponents}
              fixedHeaderContent={fixedHeaderContent}
              itemContent={tableBodyRowContent}
            />
        }
      </Paper>
    </Card>
  );
}

export default EquipmentTableCard;
